<template>
  <main>
    <slot></slot>
  </main>
</template>

<script>
export default {

}
</script>

<style lang="postcss" scoped>
  main {
    @apply flex max-w-6xl mx-auto pt-4 w-full;
  }
</style>
